<template>
	<div>
		<v-data-table
			:loading="reportDialogLoading"
			:headers="headers"
			:search="appBarSearch"
			:no-data-text="$t('no-data-available')"
			:loading-text="$t('loading')"
			:headers-length="headers.length"
			:items="billingsLinksList"
			:footer-props="getDataTableFooterProps('partnerBillingReportsTable')"
			:items-per-page="-1"
			sort-by="id"
			item-key="id"
			fixed-header
			dense
			:height="pageHeight(174)">
			<template #item="{ item }">
				<tr :class="item.status === 0 ? 'secondary' : 'even-row'">
					<td class="text-left">
						<span class="font-weight-medium font-size13 d-flex align-items-center">
							<v-img style="max-height: 18px; max-width: 18px; margin-right: 4px" :src="profileSettingsBlack"></v-img>
							{{ item.linkCreatedByFullname }}
						</span>
					</td>
					<td class="text-left font-weight-medium font-size13">
						{{ formatBillingDate(item.billingMonth, item.billingYear) }}
					</td>
					<td class="text-left">
						<v-icon size="20" color="primary">mdi-calendar-clock</v-icon>
						<span class="font-weight-medium font-size13">{{ formatDate(item.expiresAt) }}</span>
					</td>
					<td class="text-left">
						<span class="font-weight-medium font-size13">{{ checkStatus(item.status) }}</span>
					</td>
					<td class="text-left">
						<v-icon
							class="font-weight-medium pl-9 font-size20"
							:class="item.isEmailDownloaded ? 'color-green' : 'color-primary'">
							{{ item.isEmailDownloaded ? 'mdi-check-circle' : 'mdi-close-circle' }}
						</v-icon>
					</td>
					<td class="text-right">
						<v-btn :disabled="item.status != 1" x-small color="primary" @click="downloadCSV(item)">
							Download CSV
						</v-btn>
					</td>
					<td class="text-right">
						<v-icon
							:disabled="item.status != 1"
							class="icon-img mdi-18px"
							color="black"
							@click="openPreviewDialog(item)">
							mdi-eye
						</v-icon>
					</td>
				</tr>
			</template>
		</v-data-table>
		<ReportsDialog v-if="reportDialog" @close-dialog="reportDialog = false" :dialog.sync="reportDialog" />
	</div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { profileSettingsBlack } from '@/assets';
import ReportsDialog from '@/views/Client/components/ReportsDialog.vue';
import { getDataTableFooterProps } from '@/utils/utilities';
export default {
	name: 'BillingReports.vue',
	components: { ReportsDialog },
	data () {
		return {
			reportDialog: false,
			reportDialogLoading: true,
			dialogEmail: false,
			selectedItemToEmail: null,
			selectedItemId: null,
		};
	},
	computed: {
		profileSettingsBlack () {
			return profileSettingsBlack;
		},
		...mapState({
			billingsLinksList: (state) => state.billings.billingsLinksList,
			authenticated: (state) => state.authentication.userData,
		}),
		...mapGetters({
			pageHeight: 'pageHeight',
			appBarBillingDate: 'filterbar/getBillingDate',
			appBarSearch: 'filterbar/getSearch',
		}),
		headers () {
			const headers = [
				{ text: this.$t('created-by'), value: 'linkCreatedByFullname', align: 'start' },
				{ text: this.$t('billing-month'), value: 'billingMonth', align: 'start' },
				{ text: this.$t('expires-at'), value: 'expiresAt', align: 'start' },
				{ text: this.$t('status'), value: 'status', align: 'start' },
				{ text: this.$t('report-downloaded'), value: 'isEmailDownloaded', align: 'start' },
				{ text: '', value: '', align: 'end pr-7' },
				{ text: this.$t('details'), value: '', align: 'end', width: 20 },
			];
			return headers;
		},
	},
	created () {
		this.getBillingOrganizationLinks();
		// this.getPartners();
	},
	methods: {
		...mapMutations({
			updateDownloadedStatus: 'billings/UPDATE_BILLING_LINKS_IS_DOWNLOADED',
		}),
		getDataTableFooterProps,
		async openPreviewDialog (item) {
			this.reportDialogLoading = true;

			const request = {
				organizationId: item.organizationId,
				month: item.billingMonth,
				year: item.billingYear,
			};
			await this.$store.dispatch('billings/getCsvDataForMonth', request).then((resp) => {
				this.reportDialog = true;
				this.reportDialogLoading = false;
			});
		},
		formatBillingDate (billingMonth, billingYear) {
			const date = new Date(billingYear, billingMonth - 1, 1); // Create a Date object with the first day of the month
			return date.toLocaleDateString('en-US', {
				month: 'short',
				year: 'numeric',
			});
		},
		async downloadCSV (item) {
			try {
				const link = document.createElement('a');
				link.href = item.linkUrl;
				link.setAttribute('download', 'file.csv');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} finally {
				this.updateDownloadedStatus(item.id);
			}
		},
		async getPartners () {
			const organizationId = this.roleName === 'SYSTEM_ADMIN' ? -1 : this.authenticated.organizationId;
			const body = {
				organizationId: organizationId,
			};

			await this.$store.dispatch('users/getPartners', body);
		},
		formatDate (dateString) {
			const date = new Date(dateString); // Convert the string to a Date object
			return date.toLocaleDateString('en-US', {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
			});
		},
		// 1-Active, 2-Expired, 3-Used
		checkStatus (status) {
			switch (status) {
				case 1:
					return this.$t('active');
				case 2:
					return this.$t('expired');
				case 3:
					return '';
				default:
					return 'Expired';
			}
		},
		async deleteSurveyById (item) {
			this.selectedItemId = item.id;
			this.reportDialog = true;
		},
		async sendEmail (item) {
			this.selectedItemToEmail = item;
			this.dialogEmail = true;
		},
		synchronizeDrawers (item) {
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', {
				updateDrawer: true,
				page2: 'links',
				item: item,
			});
		},
		closeDeleteDialog () {
			this.reportDialog = false;
			// this.surveyId = '';
		},
		closeEmailDialog () {
			this.dialogEmail = false;
			// this.surveyId = '';
		},
		async getBillingOrganizationLinks () {
			this.reportDialogLoading = true;
			await this.$store.dispatch('billings/getBillingLinksForOrganization');
			this.reportDialogLoading = false;
		},
	},
};
</script>
